import { render, staticRenderFns } from "./ShareButtons.vue?vue&type=template&id=5b1ac54c&scoped=true&"
import script from "./ShareButtons.vue?vue&type=script&lang=ts&"
export * from "./ShareButtons.vue?vue&type=script&lang=ts&"
import style0 from "./ShareButtons.vue?vue&type=style&index=0&id=5b1ac54c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1ac54c",
  null
  
)

export default component.exports